import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';
import { RegionService } from '../proxy/planning/controllers/region.service';
import { SpeciesService } from '@general/proxy/general/controllers/species.service';
import { GeneticMaterialTypeService } from '@general/proxy/general/controllers/genetic-material-type.service';

FieldBuilder.setNamespace('Planning');

export const CROPCODE_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .number('dominantHeight', 'Entity.CropCode.DominantHeight')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .number('treeCount', 'Entity.CropCode.TreeCount')
    .required()
    .build(),
  FieldBuilder
    .number('averageVolume', 'Entity.CropCode.AverageVolume')
    .required()
    .decimal(2,10)
    .build(),
  FieldBuilder
    .number('mediumAnnualIncrement', 'Entity.CropCode.MediumAnnualIncrement')
    .decimal(1,10)
    .build(),
  FieldBuilder
    .checkbox('isOwnPlantation', 'Entity.CropCode.IsOwnPlantation')
    .build(),
  FieldBuilder
    .foreignKey('geneticMaterialTypeId', 'Entity.CropCode.GeneticMaterialType', GeneticMaterialTypeService)
    .display('name')
    .keyField('id')
    .build(),
  FieldBuilder.foreignKey('regionId', 'Entity.Region', RegionService)
    .required()
    .displayFromNested('region.name')
    .sortBy('region.name')
    .build(),
  FieldBuilder.foreignKey('speciesId', 'Entity.CropCode.Species', SpeciesService)
    .required()
    .display('name')
    .keyField('id')
    .build(),
];

export const CROPCODE_CONFIG = {
  entityName: 'CropCode',
  localizationKey: 'Planning::Entity.CropCode',
  fields: CROPCODE_FIELDS,
  permission: 'PlanningInventory.CropCodes',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.Inventory + MENU_NAME_SUFFIX,
};
